// extracted by mini-css-extract-plugin
export var banner = "_i9-0";
export var closeButton = "_i9-2";
export var greenCheckmark = "_i9-3";
export var hereLink = "_i9-4";
export var titleIcon = "_i9-1";